import { Box, CircularProgress, Typography } from "@mui/material";
import type { RefObject, UIEvent } from "react";
import MessageRow from "./MessageRow";

type Props = {
  messages: any[];
  messagesLoading: boolean;
  isFetchingOlder: boolean;
  highlightedMessageId: string | null;
  reactionPickerForId: string | null;
  onScroll: (event: UIEvent<HTMLDivElement>) => void;
  threadBodyRef: RefObject<HTMLDivElement>;
  onReply: (message: any) => void;
  onToggleReactionPicker: (messageId: string) => void;
  onToggleReaction: (messageId: string, emoji: string) => void;
  onScrollToReply: (targetId?: string | null) => void;
  onImagePreview: (preview: { src: string; title?: string }) => void;
  resolveParticipantName: (
    senderId?: string | null,
    senderRole?: string | null
  ) => string;
  currentUserId?: string;
  role?: string;
};

const MessagesThreadBody = ({
  messages,
  messagesLoading,
  isFetchingOlder,
  highlightedMessageId,
  reactionPickerForId,
  onScroll,
  threadBodyRef,
  onReply,
  onToggleReactionPicker,
  onToggleReaction,
  onScrollToReply,
  onImagePreview,
  resolveParticipantName,
  currentUserId,
  role,
}: Props) => {
  return (
    <Box className="messages-thread-body" ref={threadBodyRef} onScroll={onScroll}>
      {isFetchingOlder && (
        <Box className="messages-history-loader">
          <CircularProgress size={20} />
        </Box>
      )}
      {messagesLoading && messages.length === 0 ? (
        <Box className="messages-empty">
          <CircularProgress size={28} />
        </Box>
      ) : messages.length === 0 ? (
        <Box className="messages-empty">
          <Typography variant="body1" fontWeight={600}>
            No messages yet
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Send the first message to start the conversation.
          </Typography>
        </Box>
      ) : (
        messages.map((message: any, index: number) => {
          const previousMessage = index > 0 ? messages[index - 1] : null;
          const isOutgoing = message?.senderId?.toString() === currentUserId;

          return (
            <MessageRow
              key={message?._id?.toString?.() || message?._id || index}
              message={message}
              previousMessage={previousMessage}
              isOutgoing={isOutgoing}
              highlightedMessageId={highlightedMessageId}
              reactionPickerForId={reactionPickerForId}
              onReply={onReply}
              onToggleReactionPicker={onToggleReactionPicker}
              onToggleReaction={onToggleReaction}
              onScrollToReply={onScrollToReply}
              onImagePreview={onImagePreview}
              resolveParticipantName={resolveParticipantName}
              currentUserId={currentUserId}
              role={role}
            />
          );
        })
      )}
    </Box>
  );
};

export default MessagesThreadBody;
